<template>
  <div class="custom-nonav-wrapper">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'layout-no-nav',
  computed: {
    version() {
      let _version = window.version ? window.version : ''
      return _version
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-nonav-wrapper {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/no-nav.vue